import { Box, makeStyles, 
} from '@material-ui/core';
import UtilService from '../../../../helper/service';
import { useSelector } from 'react-redux';


const useStyles = makeStyles((theme) => ({
  statuscontent: {
    fontFamily: 'Spartan-bold',
    color: '#697683',
    textAlign: 'right',
    paddingTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end"
  },
  statusicon: {
    width: 24,
    height: 24
  },
  statustitle: {
    fontFamily: 'Spartan-bold',
    fontSize: 25,
    color: '#1DB859',
    marginTop: 4
  },
  statustxt: {
    color: '#697683',
    fontSize: 20,
    fontFamily: 'Spartan-bold',
    paddingTop: theme.spacing(1),
    textTransform: 'capitalize'
  },
  icon: {
    width: 24,
    height: 24
  },
  tooltipDiv: {
    display: 'flex',
    alignItems: 'center'
  }
}));

interface IProps {
  pathname: string;
  isMobile: boolean;
}

const ExperienceManagerAsyncSection = (props: IProps) => {

  const classes = useStyles();
  const { isMobile } = props;
  const {currentSession} = useSelector((state: any) => state.analysis);
  const { session_status } = currentSession;
     
  return (
    <>
      {!isMobile && (
        <Box className={classes.statuscontent}>
          <Box className={classes.statustxt}>
            {UtilService.formattingString(session_status)}
          </Box>
        </Box>
      )}
    </>
  );
}

export default ExperienceManagerAsyncSection;
